module.exports = __webpack_public_path__ + "img/preview.aac97479.png";